import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
  },
  rate: {
    color: theme.palette.grey.main,
    fontSize: 11
  },
  currenciesContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 'auto',
    padding: theme.spacing(1),
  },
  currenciesHeaderText: {
    fontSize: 11,
  },
  buttonGroup: {
    padding: theme.spacing(1, 0)
  },
  radio: {
    '&$checked': {
      color: '#000000'
    }
  },
  checked: {},
  button: {
    fontWeight: 600,
    fontSize: 12,
    flexBasis: 0
  },
}));

export default useStyles;
